import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const TextEditorWrapper = styled(Box)<{
  isDisabled?: boolean;
  isReadonly?: boolean;
  minHeight?: number | string;
  border?: string;
  borderTop?: string;
  padding?: string;
  backgroundColor?: string;
  overflow?: string;
}>`
  border: ${({ border }) => (border ? border : `2px solid ${theme.colors.black}`)};
  border-radius: ${theme.borderRadius};
  overflow: hidden;

  & a {
    text-decoration: underline;
    color: ${theme.colors.blue};
  }

  & .ck-toolbar_grouping,
  .ck-sticky-panel__content {
    border-radius: 16px 16px 0 0 !important;
  }

  .ck-sticky-panel__content {
    border: none !important;
  }

  .ck-editor__editable_inline {
    border-radius: 0 0 16px 16px !important;
    border: none !important;
    min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '200px')} !important;
    padding: ${({ padding }) => (padding ? `${padding} !important` : '10px !important')};
    background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : 'white')};
  }

  .ck-editor__main {
    border-radius: 0 0 16px 16px !important;
    border-top: ${({ borderTop }) => (borderTop ? borderTop : `1px solid ${theme.colors.black200}`)};
    height: fit-content;
  }

  // & > .ck-rounded-corners {
  //   width: 100% !important;
  //   border: 2px solid ${theme.colors.black}!important;
  //   border-radius: ${theme.borderRadius}!important;
  //   box-shadow: 1px 1px 1px 1px !important;
  // }

  .ck-editor__editable {
    background: ${({ backgroundColor, isReadonly }) =>
      backgroundColor ?? (!isReadonly ? theme.colors.white : 'transparent')} !important;
    overflow: ${({ overflow }) => overflow || 'hidden'} !important;
  }

  ${({ isDisabled }) =>
    isDisabled &&
    `
      .ck-editor__editable {
        background: ${theme.colors.black300}!important;
        border-radius: 0 !important;
        border-top: 0 !important;
      }
      .ck-editor__main {
        border-top: 0 !important;
      }
  `};
`;

export const ReviewTextEditorWrapper = styled(Box)<{
  paragraphFontSize?: number;
}>`
  & h5 {
    font-weight: ${theme.fontWeights.bold};
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 0;
  }

  & p {
    margin: 0 !important;
    font-size: ${({ paragraphFontSize }) => (paragraphFontSize ? `${paragraphFontSize}px` : 'auto')};
  }
`;
